import React, { Component } from 'react';
import { AutoComplete, Button, Input, Select, message, DatePicker } from 'antd';
import SearchInput from '../../common/SearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    state = {
        maxMonth: '',
        searchParams: {},
        areaList: [],
        diseaseList: [],
        companyOptions: [],
        customerTypeList: [],
    }

    componentDidMount() {
        const { activeKey } = this.props;
        if (activeKey == 'compareRecord') {
            this.loadAreaList();
        } else if (activeKey == 'mainCustomManager') {
            this.queryCustomerType();
        } else if (activeKey == 'teamContribute') {
            this.queryDate();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.activeKey != 'teamContribute' && nextProps.activeKey == 'teamContribute') {
            this.queryDate();
        }
    }

    queryDate = () => {
        const options = {
            url: API_URL.user.queryPmScoreGradeDate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                const { searchParams } = this.state;
                searchParams.inspectionTime = date;
                const maxMonth = date;
                this.setState({
                    maxMonth,
                    searchParams,
                }, () => {
                    this.search();
                });
            },
        };
        $.sendRequest(options);
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllInvestigationArea,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ areaList: res.data });
        });
    }

    loadDiseaseList = investigationAreaId => {
        dictCache.getDict(`DISEASE_AREA_${investigationAreaId}`, cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllDisease,
                data: { investigationAreaId },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ diseaseList: res.data });
        });
    }

    search = () => {
        const { searchParams, searchParams: { customerId }, companyOptions } = this.state;
        if (customerId) {
            const isExist = companyOptions.some(item => item.value == customerId);
            if (!isExist) {
                message.warning('请选择正确的客户名称');
                return;
            }
        }
        this.props.search({ ...searchParams });
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    onStartChange = (data, dateString) => {
        const { searchParams } = this.state;
        searchParams.inspectionTime = dateString;
        this.setState({ searchParams });
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        if (field == 'investigationAreaId') {
            searchParams.diseaseId = undefined;
            searchParams.originalDiseaseName = '';
        }
        this.setState({ searchParams }, () => {
            if (field == 'investigationAreaId') {
                const { searchParams: { investigationAreaId } } = this.state;
                if (!investigationAreaId) {
                    this.setState({ diseaseList: [] });
                } else {
                    this.loadDiseaseList(investigationAreaId);
                }
            }
        });
    }

    diseaseSearch = (value) => {
        const { searchParams, searchParams: { investigationAreaId } } = this.state;
        searchParams.originalDiseaseName = value;
        this.setState({ searchParams });
        const options = {
            method: 'POST',
            url: API_URL.common.queryAllDisease,
            data: {
                keyword: value,
                investigationAreaId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    diseaseList: res.data,
                });
                if (res.data && res.data.length == 0) {
                    searchParams.diseaseId = '';
                    this.setState({ searchParams });
                }
            }
        };
        $.sendRequest(options);
    }

    // 客户名称
    companySelectChange = value => {
        const { searchParams } = this.state;
        if (value) {
            searchParams.customerId = value.key;
        } else {
            searchParams.customerId = '';
        }
        this.setState({ searchParams });
    }

    parseCompanyData = (res, value) => {
        if ((res.data || res.datas) ) {
            const sourceData = res.data;
            const data = sourceData.map(item => ({
                text: `${item.customerCompanyName}`,
                value: item.customerCompanyId,
            }));
            this.setState({ companyOptions: data });
        } else {
            this.setState({ companyOptions: [] });
        }
    }

    // 客户类型
    queryCustomerType = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryCustomerType,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    customerTypeList: res.customerTypeList,
                });
            }
        };
        $.sendRequest(options);
    }

    disabledDate = (current) => {
        const { maxMonth } = this.state;
        return current && current.valueOf() >= moment(maxMonth).add(1, 'M').valueOf();
    }

    render() {
        const { activeKey, canSynchronize, synchronizeUser } = this.props;
        const {
            areaList,
            diseaseList,
            companyOptions,
            customerTypeList,
            searchParams: {
                inspectionTime,
                investigationAreaId,
            }
        } = this.state;
        const newInspectionTime = inspectionTime ? moment(inspectionTime) : null;
        const areaOption = areaList.map(d => <Option key={d.investigationAreaId}>{d.investigationAreaName}</Option>);
        const diseaseOption = diseaseList.map(d => <Option key={d.diseaseId} showValue={d.diseaseName}>{d.diseaseName}</Option>);
        const customerTypeOption = customerTypeList.map(d => <Option key={d.customerTypeId}>{d.customerTypeName}</Option>);
        return (
            <div className="filter-bar">
                <div className="filter-bar-investigation">
                    {
                        activeKey == 'teamContribute' &&
                        <div className="form-item">
                            <label className="ui-label">考核时间</label>
                            <MonthPicker
                                style={{width:90}}
                                format={monthFormat}
                                value={newInspectionTime}
                                placeholder="请选择"
                                allowClear={false}
                                disabledDate={this.disabledDate}
                                onChange={this.onStartChange}
                                className="w-90-select"
                            />
                        </div>
                    }
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">工号</label>
                        <Input
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'employeeCode')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">姓名</label>
                        <Input
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'userCompellation')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    {
                        activeKey == 'overView' &&
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">工作城市</label>
                            <Input
                                placeholder="请输入"
                                onChange={e => this.handleInputChange(e, 'workCity')}
                                onKeyPress={this.enterSearch}
                                style={{width:120}}
                            />
                        </div>
                    }              
                    {
                        activeKey == 'overView' &&
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">状态</label>
                            <Select
                                onChange={value => this.handleSelectChange(value, 'workStatus')}
                                placeholder="请选择"
                                style={{width:90}}
                                allowClear={true}
                            >
                                <Option value="WORKING">在职</Option>
                                <Option value="LEFT">离职</Option>
                            </Select>
                        </div>
                    }
                    {
                        activeKey == 'mainCustomManager' &&
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">客户类型</label>
                            <Select
                                onChange={value => this.handleSelectChange(value, 'customerTypeId')}
                                placeholder="请选择"
                                style={{width:90}}
                                allowClear={true}
                            >
                                {customerTypeOption}
                            </Select>
                        </div>
                    }
                    {
                        (activeKey == 'compareRecord' || activeKey == 'mainCustomManager') &&
                        <div className="form-item">
                            <label className="ui-label">客户名称</label>
                            <SearchInput
                                keyword='customerCompanyName'
                                style={{ width: 162 }}
                                placeholder="请输入客户名称检索"
                                url={API_URL.investigation.queryCustomerCompanyByName}
                                dataSource={companyOptions}
                                parseData={this.parseCompanyData}
                                handleSelect={this.companySelectChange}
                            />
                        </div>
                    }
                    {
                        (activeKey == 'compareRecord') &&
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">项目领域</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{ width: 100 }}
                                onChange={value => this.handleSelectChange(value, 'investigationAreaId')}
                            >
                                {areaOption}
                            </Select>
                        </div>
                    }
                    {
                        (activeKey == 'compareRecord') &&
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">疾病</label>
                            {
                                investigationAreaId ?
                                    <AutoComplete
                                        allowClear={true}
                                        onSearch={this.diseaseSearch}
                                        style={{ width: 110 }}
                                        optionLabelProp="showValue"
                                        placeholder="请输入疾病检索"
                                        onChange={value => this.handleSelectChange(value, 'diseaseId')}
                                    >
                                        {diseaseOption}
                                    </AutoComplete>
                                :
                                    <Input
                                        placeholder="请输入"
                                        style={{ width: 110 }}
                                        onChange={e => this.handleInputChange(e, 'originalDiseaseName')}
                                        onKeyPress={this.enterSearch}
                                    />
                            }
                        </div>
                    }
                    <div className="form-item">
                        <Button type="primary" onClick={this.export}>导出</Button>
                        {
                            activeKey == 'teamContribute' &&
                            (
                                canSynchronize ?
                                    <Button type="primary" onClick={synchronizeUser} style={{ background: '#62cf96', border: '1px solid #00a854' }}>同步人员</Button>
                                :
                                    <Button disabled={true}>同步人员</Button>
                            )
                        }
                        <Button type="primary" onClick={this.search}>搜索</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/user/pmInfo/Filter.js